import PropTypes from 'prop-types';
import { MenuState, Store } from 'store/types';
import { NavGroupType, NavItemType } from '../../../../../menu-items/types';

import { Box, List, Typography } from '@mui/material';
import NavItem from './NavItem';

import { useSelector } from 'react-redux';
import { useTranslation } from '../../../../../contexts/TranslationContext';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

type NavGroupProps = {
    item: NavGroupType;
};

const NavGroup = ({ item }: NavGroupProps) => {
    const menu = useSelector<Store, MenuState>(state => state.menu);
    const { translate } = useTranslation();
    const { drawerOpen } = menu;

    const navCollapse = Object.values(item.children).map(
        (menuItem: NavItemType) => {
          return (
            <NavItem key={menuItem.id} item={menuItem} level={1} />
          );
        },
    );

    return (
        <List
            subheader={
                item.title && (
                <Box sx={{ pl: 3, mb: 1 }}>
                  {drawerOpen ? (
                    <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">
                      {translate(item.title)}
                    </Typography>
                  ) : (
                    <Box sx={{height: 12, mb: 2}} />
                  )}
                  {/* only available in paid version */}
                </Box>
              )
            }
            sx={{ mb: 2, py: 0, zIndex: 0, overflowX: 'hidden' }}>
            {navCollapse}
        </List>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
};

export default NavGroup;
